import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=298095ee&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"
import style1 from "./appMain.vue?vue&type=style&index=1&id=298095ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298095ee",
  null
  
)

export default component.exports